export interface IFieldWalkthrough {
  fieldWalkthroughId: number;
  lotNumber: number;
  neighborhoodDescription: string | null;
  planDescription: string | null;
  createdOn: string;
  createdBy: string | null;
  walkthroughStatus: string;
}

export interface IFieldWalkthroughDetail {
  fieldWalkthroughId: number;
  jobId: number;
  lotNumber: number;
  sageJobId: number;
  neighborhoodDescription: string;
  punchlistId: number | null;
  punchlistName: string | null;
  neighborhoodId: number;
  neighborhoodName: string;
  neighborhoodPhase: string;
  items: IFieldWalkthroughDetailItem[];
  block: string;
  territoryId: number;
  assignedTo: string | null;
  hasOpenItems: boolean;
  hasAvailableMarkups: boolean;
}

export interface IFieldWalkthroughDetailItem {
  text: string;
  notApplicableMarked: boolean;
  notes: string;
  foremanResponse: string;
  supervisorResponse: string;
  projectManagerResponse: string;
  fieldWalkthroughLocationId: number;
  fieldWalkthroughItemId: number;
  hasPhoto: boolean;
  hasPunchlistItem: boolean;
  assignedTo: string | null;
  partnerId: number | null;
  partnerName: string;
  isPunchlistItemComplete: boolean;
  assignedToDisplayName: string;
  markupFiles: IFieldWalkthroughItemMarkup[];
}

export interface IFieldWalkthroughLocation {
  fieldWalkthroughLocationID: number;
  fieldWalkthroughLocationName: string;
}

export interface IFieldWalkthroughTerritory {
  territoryId: number;
  territoryName: string;
}

export interface INewFieldWalkthroughOptions {
  territoryId: number;
  neighborhoodId: number;
  lotNumber: number;
}

export interface IUpdateFieldWalkthroughOptions {
  items: IFieldWalkthroughDetailItem[];
}

export interface ICreateFieldWalkthroughError {
  NeighborhoodId?: string[];
  FieldWalkthroughId?: string[];
}

export interface IFieldWalkthroughDefaultMarkup {
  description: string;
  fileContents: string;
  contentType: string;
  fileDownloadName: string;
  lastModified: string | null;
  entityTag: string | null;
  enableRangeProcessing: boolean;
}

export interface IFieldWalkthroughItemMarkup {
  description: string;
  fieldWalkthroughItemFileId: number;
  originalFileName: string;
  storageUri: string;
  xmlAnnotationData?: string;
}

export interface IUnassignedFieldWalkthroughItem {
  text: string;
}

export interface IConsolidatedFloorPlanResult {
  floorplanName: string;
  xmlAnnotations: IConsolidatedFloorPlanAnnotation[];
}

export interface IConsolidatedFloorPlanAnnotation {
  fieldWalkthroughItemFileId: number;
  originalFileName: string;
  description: string;
  xmlAnnotationData: string;
}

export enum FieldWalkthroughResponse {
  MeetsStandards = 'Meets Standards',
  RepairReplace = 'Repair / Replace'
}
